import { contactCard } from '../../../shared';

export const buyerCard = contactCard('buySideContacts.buyerX', 'client');
